import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';

@HookClass('data.assign')
export class AssignHook extends BaseHook {

    @Hook('c2f5827c-b404-440b-9a36-0a1eed308da4')
    public assign(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const output = new NickProcessArtfact();
        output.kind = ArtfactKind.ANY;
        output.object = Object.assign({}, ...input.object.data);
        return of(output);
    }

}
